<template functional>
  <div class="col">
    <el-tag type="success">
      {{ props.row.PaymentDay }}
    </el-tag>
  </div>
</template>

<script>
import get from "lodash/get";
const arrayGet = get;
export default {
  name: "ColorPaymentDay",
  props: {
    // imgKey: {
    //   type: String,
    //   required: false,
    //   default: null
    // },
    //column: String,
    row: Object
  },
  customRender(props) {
    //console.log(props.row)
    return arrayGet(props.row.PaymentDay);
  }
};
</script>

<style scoped>
.col {
  height: auto;
}
</style>
